import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentAllListItemWireframe from './VeltNotificationsPanelContentAllListItemWireframe/VeltNotificationsPanelContentAllListItemWireframe';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltNotificationsPanelContentAllListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllListWireframe.Item = VeltNotificationsPanelContentAllListItemWireframe;
export default VeltNotificationsPanelContentAllListWireframe;
